import axiosInstance from '@/plugins/axios';

export default class ServiceEmpregadores {
  // Empregadores = empresas ativas da VIEW FDW `companies`, via /agnes/companies do BFF.
  // (Antes: establishment-company/userid — domínio local vazio; e /empresas — tabela `empresa`
  //  + filtro user-service, que retornava [] sem atribuição.)
  static listar = () => axiosInstance.get('agnes/companies');
}
